import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { PersonelLogin } from 'src/app/models/Personel';
import { NotifymodalComponent } from 'src/app/notifymodal/notifymodal.component';
import { AuthService } from 'src/app/services/auth.service';
import { PersonelService } from 'src/app/services/personel.service';


@Component({
  selector: 'app-sifre-degistir',
  templateUrl: './sifre-degistir.component.html',
  styleUrls: ['./sifre-degistir.component.css']
})
export class SifreDegistirComponent implements OnInit {


  user: PersonelLogin;

  public passwordForm = new FormGroup({
    password: new FormControl(''),
    passwordRepeat: new FormControl(''),
  });

  constructor(
    public personelService: PersonelService,
    public authService: AuthService,
    public dialog:MatDialog,
    public router:Router,
  ) { 
    this.user= this.authService.getLoginDetails();
  }

  ngOnInit(): void {
  }

  changePassword() {
    //console.log(this.passwordForm.value.password.length);
    if(this.passwordForm.value.password !== this.passwordForm.value.passwordRepeat){
      console.log("Lütfen iki alanında eşit olduğundan emin olun.");
    }else {
      this.personelService.changePasword(this.passwordForm.value.password,this.passwordForm.value.passwordRepeat).subscribe(res => {
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess:true, 
            text:"Şifre değiştirme başarılı.",
            subject:"Şifre Değiştirme"
          }
        }).afterClosed().subscribe(()=>{
          this.authService.logout();
          this.router.navigate(['']);
        });
      },
      error => {
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess:false, 
            text:"Şifre değiştirme başarısız.",
            subject:"Şifre Değiştirme"
          }
        });
      });
    }
    
    //console.log(JSON.stringify(this.passwordForm.value));
  }

  get password() { return this.passwordForm.get('password'); }
  get passwordRepeat() { return this.passwordForm.get('passwordRepeat'); }

}


